import styled from 'styled-components';

export const NavigationBar = styled.div`
	width: 100%;
	max-width: 768px;
	padding: 8px 66px 15px 66px;
	box-shadow: 0px 0px 25px 0px rgba(30, 15, 5, 0.1);

	display: flex;
	justify-content: space-between;
	align-items: center;

	background-color: white;
`;

export const NavigationBarItem = styled.div`
	width: 50px;
	padding: 4px 4px 4px 5px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
`;
